<template>
  <a-drawer :label-col="4" :visible="open" :wrapper-col="14" width="35%" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="反馈类型" prop="type">
        <a-select v-model="form.type" placeholder="请选择反馈类型" :disabled="form.id !== null">
          <a-select-option :value="1">意见建议</a-select-option>
          <a-select-option :value="2">故障报告</a-select-option>
          <a-select-option :value="3">投诉</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="反馈内容" prop="content">
        <editor v-model="form.content"/>
      </a-form-model-item>
      <a-form-model-item label="反馈图片" prop="imgUrls" v-if="form.imgUrls" >
        <img v-for="img in form.imgUrls.split(',')" :src="img" style="height: 50px;width: 50px">
      </a-form-model-item>
      <a-form-model-item label="联系方式" prop="contact">
        <a-input v-model="form.contact" placeholder="请输入联系方式" :disabled="form.id !== null"/>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>
      <a-form-model-item label="处理状态" prop="processStatus">
        <a-select v-model="form.processStatus" placeholder="请选择处理状态">
          <a-select-option :value="1">待处理</a-select-option>
          <a-select-option :value="2">已处理</a-select-option>
          <a-select-option :value="3">暂不处理</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="处理结果" prop="processResult">
        <a-input v-model="form.processResult" placeholder="请输入处理结果"/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button :loading="submitLoading" type="primary" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {addFeedback, getFeedback, updateFeedback} from '@/api/app/feedback'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    Editor
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        type: null,

        content: null,

        processStatus: 0,

        processResult: null,

        imgUrls: null,

        contact: null,

        remark: null,

        createTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          {required: true, message: '用户id，外键{user.id}不能为空', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '反馈类型：1-意见建议、2-故障报告、3-投诉不能为空', trigger: 'change'}
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        content: null,
        processStatus: 0,
        processResult: null,
        imgUrls: null,
        contact: null,
        remark: null,
        createTime: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getFeedback({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = response.data.processStatus === 1 ? '处理' : '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateFeedback(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addFeedback(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
